import gql from "graphql-tag";

export default gql`
	query Reports($school_id: ID, $linked_only: Boolean, $status: String, $datetime_from: String, $cursor: Int) {
		Reports(school_id: $school_id, linked_only: $linked_only, status: $status, datetime_from: $datetime_from, cursor: $cursor) {
			results {
				id
				run_by_company_id
				run_by_user_id
				user_first_name
				user_last_name
				company_name
				school_name
				status
				queue
				report_name
				school_id
				created_at
				run_at
			}
			cursor
		}
	}
`;
